'use strict';
import 'toolbar.module';
import 'print.module';
import 'query.module';
import 'search.module';
import 'measure.module';
import 'draw.module';
import 'permalink.module';
import 'info.module';
import 'datasource-selector.module';
import 'sidebar.module';
import 'add-layers.module';
import { Tile, Group, Image as ImageLayer } from 'ol/layer';
import { TileWMS, WMTS, OSM, XYZ } from 'ol/source';
import { ImageWMS, TileArcGISRest } from 'ol/source';
import View from 'ol/View';
import { transform } from 'ol/proj';

var module = angular.module('hs', [
    'hs.sidebar',
    'hs.toolbar',
    'hs.layermanager',
    'hs.map',
    'hs.query',
    'hs.search', 'hs.print', 'hs.permalink', 'hs.measure',
    'hs.legend', 'hs.core',
    'hs.datasource_selector',
    'hs.save-map',
    'hs.addLayers',
    'hs.draw',
    'gettext',
    'hs.info'
]);

module.directive('hs', function (HsCore, HsLayoutService) {
    'ngInject';
    return {
        template: HsCore.hslayersNgTemplate,
        link: function (scope, element) {
            HsLayoutService.fullScreenMap(element, HsCore);
        }
    };
});

module.value('HsConfig', {
    proxyPrefix: '/proxy/', 
    box_layers: [
        new Group({
            title: 'Basemaps',
            layers: [
                new Tile({
                    source: new OSM(),
                    title: "OpenStreetMap",
                    base: true,
                    visible: true
                }),
                new Tile({
                    source: new TileArcGISRest({
                        url: 'https://ags.cuzk.cz/arcgis/rest/services/ortofoto_wm/MapServer'
                    }),
                    title: "Ortophoto ČÚZK",
                    base: true,
                    visible: false
                })
            ]
        }),
        new Group({
            title: 'Map layers',
            layers: [
                new Tile({
                    title: "Land-parcel identif. system",
                    source: new TileWMS({
                        url: 'https://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/produkcni_zony.map',
                        params: {
                            LAYERS: 'lpis_hranice',
                            FORMAT: "image/png",
                            INFO_FORMAT: "text/html",
                            minimumTerrainLevel: 15
                        },
                        crossOrigin: null
                    }),
                    legends: ['http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/produkcni_zony.map&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=lpis_hranice&format=image/png&STYLE=default'],
                    maxResolution: 8550,
                    visible: false,
                    opacity: 1
                }),
                new Tile({
                    title: "Open-Land-Use (WMS)",
                    source: new TileWMS({
                        url: 'http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/olu/openlandusemap.map',
                        params: {
                            LAYERS: 'olu_bbox_srid',
                            FORMAT: "image/png",
                            INFO_FORMAT: "text/html",
                            minimumTerrainLevel: 15
                        },
                        crossOrigin: null
                    }),
                    legends: ['http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/3d_olu/openlandusemap.map&service=WMS&request=GetLegendGraphic&layer=olu_bbox_srid&version=1.3.0&format=image/png&sld_version=1.1.0'],
                    maxResolution: 8550,
                    visible: false,
                    opacity: 0.7
                }),
                new Tile({
                    title: "Normalized difference vegetation index (NDVI) ",
                    source: new TileWMS({
                        url: 'http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/3d_olu/rostenice.map',
                        params: {
                            LAYERS: 'ndvi_rostenice',
                            FORMAT: "image/png",
                            INFO_FORMAT: "text/html",
                            minimumTerrainLevel: 14
                        },
                        crossOrigin: null
                    }),
                    legends: ['http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/3d_olu/rostenice.map&service=WMS&request=GetLegendGraphic&layer=ndvi_rostenice&version=1.3.0&format=image/png&sld_version=1.1.0'],
                    maxResolution: 8550,
                    visible: false,
                    opacity: 0.7
                }),
                new Tile({
                    title: "Yield potential Rostenice",
                    source: new TileWMS({
                        url: 'http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/3d_olu/rostenice.map',
                        params: {
                            LAYERS: 'yield_potential',
                            FORMAT: "image/png",
                            INFO_FORMAT: "text/html",
                            minimumTerrainLevel: 14
                        },
                        crossOrigin: null
                    }),
                    legends: ['http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/dima/maps/3d_olu/rostenice.map&service=WMS&request=GetLegendGraphic&layer=yield_potential&version=1.3.0&format=image/png&sld_version=1.1.0'],
                    maxResolution: 8550,
                    visible: true,
                    opacity: 0.7
                })
            ]
        })
    ],
    componentsEnabled: {
        sidebar: true,
        toolbar: true,
        guiOverlay: true,
        drawToolbar: false,
        searchToolbar: true,
        measureToolbar: false,
        golocationButton: false,
        mapControls: true
    },
    panelsEnabled: {
        composition_browser: true,
        datasource_selector: true,
        mobile_settings: false,
        measure: true,
        draw: true,
        print: true,
        saveMap: false,
        language: false,
        compositionLoadingProgress: true
    },
    default_view: new View({
        center: transform([16.8290202, 49.0751890], 'EPSG:4326', 'EPSG:3857'), //Latitude longitude    to Spherical Mercator
        zoom: 15,
        units: "m"
    }),
    theme: {
        sidebar: {
            background: 'rgb(40, 74, 109)',
            itemColor: 'white',
            activeItemColor: 'red'
        }
    },
    sidebarClosed: true,
    advanced_form: true,
    datasources: [
        {
            title: "Micka",
            url: "https://hub.sieusoil.eu/cat/csw",
            language: 'eng',
            type: "micka",
            code_list_url: '/php/metadata/util/codelists.php?_dc=1440156028103&language=eng&page=1&start=0&limit=25&filter=%5B%7B%22property%22%3A%22label%22%7D%5D'
        }
    ]
});

module.controller('Main',
    function (HsCore, HsLayoutService, HsSearchService) {
        'ngInject';
        HsCore.singleDatasources = true;
        HsLayoutService.panel_statuses['gallery'] = true;
        HsSearchService.geonamesUser = 'raitis';
    }
);
